import { render, staticRenderFns } from "./CBlockInstagram.vue?vue&type=template&id=65d3f25a&"
import script from "./CBlockInstagram.vue?vue&type=script&lang=ts&"
export * from "./CBlockInstagram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports